module.exports = "<div class=msg-popup__content> <div class=msg-popup__title> {{text}} </div> <div class=msg-popup__desc>{{description}}</div> <div class=msg-popup__buttons> {{#each buttons}} <div class=\"js-buttons msg-popup__button {{#if default}}msg-popup__button_default{{/if}}\">{{text}}</div> {{/each}} </div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/services/message/templates/message.hbs
// module id = 715
// module chunks = 0